export default "__VITE_ASSET__DgG0exOx__"